import { baseApi } from "./baseApi";
import {
  setAllTags,
  setMapValueTags,
} from "../slices/EIPMapValueDefinition.slice";

export const tagsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMapValueTag: builder.query({
      query: (mapUUID) => ({
        url: `/tags?entity=map_value_definitions&mapUUID=${mapUUID}`,
        validateStatus: (response) => {
          return response.status == 200 || response.status == 404;
        },
      }),
      async onQueryStarted(mapId, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setMapValueTags(data));
        } catch (e) {
          console.log("exception", e);
        }
      },
      transformResponse: (response) => {
        if (!response || !response.tags) {
          return [];
        }
        return response.tags;
      },
    }),
    getMapTags: builder.query({
      query: () => ({
        url: "/tags?entity=maps",
        validateStatus: (response) =>
          response.status == 200 || response.status == 404,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(setAllTags(data));
        } catch (e) {
          console.log("exception", e);
        }
      },
      transformResponse: (response) => {
        if (!response || !response.tags) {
          return [];
        }
        return response.tags;
      },
    }),
  }),
});

export const { useLazyGetMapValueTagQuery, useLazyGetMapTagsQuery } = tagsApi;
